import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Shield, Lock } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-16 px-4 bg-navy-dark text-ice relative overflow-hidden" data-id="element-239">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(197,148,42,0.15)_0%,transparent_70%)]" data-id="element-240" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-242">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-gold-light mb-6 uppercase tracking-wide" data-id="element-243">
            No dejes la protección de tu familia para mañana.
          </h2>

          <p className="font-body text-xl text-ice/90 mb-10 max-w-2xl mx-auto" data-id="element-244">
            El miedo paraliza, pero tu fe es más poderosa cuando sabes cómo
            usarla. Descarga el manual ahora mismo y empieza a ver los milagros
            hoy.
          </p>

          {/* Pulsing CTA Button */}
          <a href="https://pay.hotmart.com/Q104750181Q?checkoutMode=10" className="animate-heartbeat inline-flex items-center justify-center gap-3 px-10 py-5 text-xl font-bold text-navy-dark bg-gradient-to-r from-gold-light via-gold to-gold-dark rounded-full transition-transform duration-300 w-full md:w-auto mb-6" data-id="element-245">
            <Shield className="w-6 h-6" data-id="element-246" />
            NECESITO LA ORACIÓN HOY
          </a>

          <div className="flex flex-col items-center gap-3 mt-2" data-id="element-247">
            <div className="flex items-center gap-2 text-emerald-400 font-bold uppercase tracking-wider text-sm" data-id="element-248">
              <Lock className="w-4 h-4" data-id="element-249" />
              <span data-id="element-250">Pago con seguridad bancaria</span>
            </div>
            <div className="flex flex-wrap justify-center gap-2 opacity-80" data-id="element-251">
              <div className="h-8 px-3 bg-white rounded-md flex items-center justify-center border border-white/20 shadow-sm" data-id="element-252">
                <span className="font-bold text-[#1A1F71] text-sm italic tracking-tighter" data-id="element-253">
                  VISA
                </span>
              </div>
              <div className="h-8 px-3 bg-white rounded-md flex items-center justify-center border border-white/20 shadow-sm" data-id="element-254">
                <div className="w-4 h-4 rounded-full bg-[#EB001B] opacity-90 z-10" data-id="element-255"></div>
                <div className="w-4 h-4 rounded-full bg-[#F79E1B] opacity-90 -ml-2" data-id="element-256"></div>
              </div>
              <div className="h-8 px-3 bg-white rounded-md flex items-center justify-center border border-white/20 shadow-sm" data-id="element-257">
                <span className="font-bold text-[#00B1EA] text-xs" data-id="element-258">
                  mercado
                  <br data-id="element-259" />
                  pago
                </span>
              </div>
              <div className="h-8 px-3 bg-white rounded-md flex items-center justify-center border border-white/20 shadow-sm" data-id="element-260">
                <span className="font-bold text-[#006FCF] text-xs" data-id="element-261">AMEX</span>
              </div>
              <div className="h-8 px-3 bg-white rounded-md flex items-center justify-center border border-white/20 shadow-sm" data-id="element-262">
                <span className="font-bold text-[#003087] text-sm italic tracking-tighter" data-id="element-263">
                  PayPal
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}